import React, { ReactNode } from 'react';
import CloseButton from '@ui-kit/components/closeButton';
import styles from '../styles/modal.module.scss';
import Portal from '@ui-kit/components/portal';
import classNames from 'classnames';

export default function Modal(props: {
  title: string;
  headerBtn?: boolean;
  closeModal?: () => void;
  children: ReactNode;
  classes?: {
    modal?: string;
    header?: string;
    title?: string;
    closeBtn?: string;
    body?: string;
  };
}) {
  return (
    <Portal>
      <div className={styles.overlay}>
        <div className={classNames(styles.modal, props.classes?.modal)}>
          <header className={props.classes?.header}>
            <h1 className={props.classes?.title}>{props.title}</h1>
            <div className={props.classes?.closeBtn}>
              {props.headerBtn && props.closeModal && (
                <CloseButton close={props.closeModal} />
              )}
            </div>
          </header>
          <main className={classNames(styles.body, props.classes?.body)}>{props.children}</main>
        </div>
      </div>
    </Portal>
  );
}
